import React, { FC, useCallback } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router';
import { nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import OverviewShell from '../overview_shell/OverviewShell';

const style = require('./ProjectsOverviewPage.less');

const ProjectsOverviewPage: FC<any> = ({
	history,
	currentUser,
	childRoutes,
}): React.ReactElement => {
	const userType = nullSafeGetOrElse('userType', currentUser, 'buyer');

	const handleTabChange = useCallback(
		(key) => history.push(`/${userType}/projects/overview/${key}`),
		[history, userType]
	);

	const checkTabActive = useCallback(
		(key) => {
			const pathname = history.location.pathname;
			return pathname.indexOf(key) !== -1;
		},
		[history.location.pathname]
	);

	const tabs = [
		{
			key: 'active',
			name: 'Active',
		},
		{
			key: 'archived',
			name: 'Archived',
		},
		{
			key: 'templates/overview',
			name: 'Templates',
		},
	];

	return (
		<>
			<Route
				path={`/${userType}/projects/overview`}
				exact={true}
				render={() => (
					<Redirect
						to={{
							pathname: `/${userType}/projects/overview/active`,
						}}
					/>
				)}
			/>
			<OverviewShell
				title="Projects"
				tabs={tabs}
				onTabChange={handleTabChange}
				checkTabActive={checkTabActive}
				childRoutes={childRoutes}
				className="projectsPage"
			/>
		</>
	);
};

const mapStateToProps = (state, ownProps) => ({
	currentUser: state.session.currentUser,
});
const mapDispatchToProps = (dispatch) => ({});
export default withRouter<any, any>(
	connect(mapStateToProps, mapDispatchToProps)(ProjectsOverviewPage)
);
